import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";

// Shared across all sites in this Firebase project.
const SHARED_CONFIG = {
  apiKey: "AIzaSyBhQpmYWmr-UxkCpyN5ATBFD0rkrblvIiU",
  authDomain: "spring-paratext-485221-a1.firebaseapp.com",
  projectId: "spring-paratext-485221-a1",
  storageBucket: "spring-paratext-485221-a1.firebasestorage.app",
  messagingSenderId: "511283790194",
};

const firebaseConfig = {
  ...SHARED_CONFIG,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

let analytics = null;

if (firebaseConfig.appId) {
  const app = initializeApp(firebaseConfig);
  analytics = getAnalytics(app);
}

export { analytics };
